module.exports = __webpack_public_path__ + "images/price-gains-blue-2823373d.svg";